import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Div, Text } from '@pinpoint/design-kit';

import BaseDialog from './base';
/* eslint-disable react/prop-types */

function OverrideClientTrackingDialog({ isOpen, actions, shouldTrackOff, shouldTrackNoDate, editing }) {
  let descMsg = null;
  if (shouldTrackOff) {
    descMsg = (
      <Text textSize="paragraph" textWeight="500" textColor="shade66">
        You are about to {editing ? 'update' : 'create'} a client with usage reporting disabled.
      </Text>
    );
  }
  if (shouldTrackNoDate) {
    descMsg = (
      <Text textSize="paragraph" textWeight="500" textColor="shade66">
        You are about to {editing ? 'update' : 'create'} a client with usage reporting enabled but without a usage date.
      </Text>
    );
  }
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={actions}
      title={{
        text: `Override Usage Reporting`,
        backgroundColor: 'brand500',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          descMsg,
          <Text textSize="paragraph" textWeight="500" textColor="shade66">
            Are you sure you want to override usage reporting?
          </Text>,
          <Div data-test="last-spacer" h="1.875rem" m={{ t: '1.25rem' }} />,
        ],
        buttons: [
          {
            text: 'OVERRIDE',
            textSize: 'body',
            close: true,
          },
        ],
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
OverrideClientTrackingDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }).isRequired,
};
/* eslint-enable */

export default OverrideClientTrackingDialog;
